const Localize = {
  LabelsHeading: "Record Labels",

  // Common
  ReleaseLinkText: "Releases",
  LabelLinkText: "Labels",
  ServiceLinkText: "Services",
  TeamLinkText: "Contact",
  OurServicesText: "Our Services",
  TermsConditionsText: "Terms And Conditions",
  PrivacyPolicy: "Privacy Policy ",

  // Main Header
  MainHeaderTitle: "Prime Direct ",
  MainHeaderTitle1: "Distribution",
  MainHeaderDesc:
    "Worldwide physical and digital distribution. From music lovers, to music lovers.",

  // HomePage
  ReleasesHeading:
    "THE LATEST MUSIC FROM SOME OF THE BEST LABELS IN THE WORLD RIGHT NOW",
  ReleaseButtonText: "See all releases",
  ServicesButtonText: "Discover all PDD services",

  //Releases Page
  FullCatalogue: "Full Catalogue",
  ForthComing: "Forthcoming",
  NewReleases: "New Releases",
  Represses: "Represses",
  BestSellers: "Best Sellers",
  RsdSpecials: "RSD Releases",

  //Footer

  FooterRightDesc: `Department Sixty Five, `,

  FooterRightDesc65: ` 65 Greenwich South Street,`,
  FooterRightDescLondon: `London, SE10 8NT`,
  FooterRightDescMail: `info@primedirectdist.co.uk`,

  FooterRightDescNumber: `+44 (0)20 8320 0988`,
     
  FooterBottomText:
    "| ©2021 Prime Direct Distribution Ltd. | Website By Another Kind",

  // Our Services Top
  HomeOurServicesTitle: "Your Music Where It Needs To Be",
  HomeOurServicesDesc:
    "Transparent, flexible and affordable physical and digital distribution, manufacturing, label services, PR and marketing from music lovers, to music lovers for over 20 years.",

  // Login Page
  LoginTitle: "Login",
  LoginButtonTitle: "Submit",
  ShowTitle: "Show Password",

  // Forgot Page
  ForgotTitle: "Forgot Password",
  ForgotButtonTitle: "Enter",

  // Forgot Page
  ConfirmTitle: "New Password",
  ConfirmButtonTitle: "Update",

  //setting
  AccountTitle: "Account Setting",
  ProfileTitle: "Profile",
  EmailTitle: "Email & Password",
  ChangePassword: "Change Password",
  OrdersTitle: "My orders",

  //Cart Page
  CartHeading: "Cart",

  //Not Availabale
  NotAvailable: " N/A",
  TitleNotAvailable: "Title - N/A",
  LabelNotAvailable: "Label Name - N/A",
  DescriptionNotAvailable: "Description - N/A",
  ArtistNotAvailable: "Artist Name - N/A",
  TagNotAvailable: "Tag N/A",
};

export const isCart = false;

export default Localize;
